import {jsx as $1NEjv$jsx, jsxs as $1NEjv$jsxs, Fragment as $1NEjv$Fragment} from "react/jsx-runtime";
import {createRoot as $1NEjv$createRoot} from "react-dom/client";
import {useState as $1NEjv$useState, useEffect as $1NEjv$useEffect, memo as $1NEjv$memo, useMemo as $1NEjv$useMemo, useRef as $1NEjv$useRef, useCallback as $1NEjv$useCallback} from "react";
import {BrowserRouter as $1NEjv$BrowserRouter, Routes as $1NEjv$Routes, Route as $1NEjv$Route, useParams as $1NEjv$useParams, Link as $1NEjv$Link} from "react-router";
import {createTheme as $1NEjv$createTheme, mergeMantineTheme as $1NEjv$mergeMantineTheme, DEFAULT_THEME as $1NEjv$DEFAULT_THEME, MantineProvider as $1NEjv$MantineProvider, Center as $1NEjv$Center, Paper as $1NEjv$Paper, Grid as $1NEjv$Grid, GridCol as $1NEjv$GridCol, Code as $1NEjv$Code, Container as $1NEjv$Container, Loader as $1NEjv$Loader, Table as $1NEjv$Table, Anchor as $1NEjv$Anchor, Group as $1NEjv$Group, Select as $1NEjv$Select} from "@mantine/core";
import "@mantine/core/styles.css";











class $3153bc3ffe81af94$export$2e2bcd8739ae039 {
    /**
	 * Calls the detect server api.
	 * @param path - the api path, ex. `user/login`
	 * @param data - key/value object to send as post data
	 * @param silent - whether or not to log stuff, if it happens a lot
	 * @return the response json
	 */ static async post(path, data = {}, silent = false) {
        const self = this;
        if (!path) {
            console.log('ERROR: api call needs path');
            return null;
        }
        try {
            const response = await fetch(`/api/${path}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    data: data
                })
            });
            const r = await response.json();
            if (!silent) console.log('%c[api]', 'color: #CCC;', path, r);
            // if (self.debug && !silent) self.lastApi = r;
            return r;
        } catch (error) {
            console.error('API request failed:', error);
            return null;
        }
    }
    /**
	 * Requests from detect whether or not we're logged into SourceAudio as a super admin
	 */ async auth() {
        const self = this;
        const r = await $3153bc3ffe81af94$export$2e2bcd8739ae039.post('sa/saAuth');
        if (r.content?.id) // self.user = r.content;
        return r.content;
        else return null;
    }
}





const $fa4da4836aa2485a$var$FILL_COLORS = [
    '#F5F5F5',
    'var(--mantine-color-green-2)',
    'var(--mantine-color-green-4)',
    'var(--mantine-color-green-5)',
    'var(--mantine-color-green-7)'
];
const $fa4da4836aa2485a$var$BORDER_COLORS = [
    '#E5E5E5',
    'var(--mantine-color-green-2)',
    'var(--mantine-color-green-3)',
    'var(--mantine-color-green-4)',
    'var(--mantine-color-green-4)'
];
function $fa4da4836aa2485a$export$f7f5ac72fdf9da26(count) {
    const c = count || 0;
    if (c >= 20) return {
        fill: $fa4da4836aa2485a$var$FILL_COLORS[4],
        border: $fa4da4836aa2485a$var$BORDER_COLORS[4]
    };
    if (c >= 10) return {
        fill: $fa4da4836aa2485a$var$FILL_COLORS[3],
        border: $fa4da4836aa2485a$var$BORDER_COLORS[3]
    };
    if (c >= 5) return {
        fill: $fa4da4836aa2485a$var$FILL_COLORS[2],
        border: $fa4da4836aa2485a$var$BORDER_COLORS[2]
    };
    if (c >= 1) return {
        fill: $fa4da4836aa2485a$var$FILL_COLORS[1],
        border: $fa4da4836aa2485a$var$BORDER_COLORS[1]
    };
    if (c < 0) return {
        fill: '#FFF',
        border: 'var(--mantine-color-red-2)'
    };
    return {
        fill: $fa4da4836aa2485a$var$FILL_COLORS[0],
        border: $fa4da4836aa2485a$var$BORDER_COLORS[0]
    };
}
const $fa4da4836aa2485a$var$StationHeatmap = /*#__PURE__*/ (0, $1NEjv$memo)(({ station: station, squaresPerColumn: squaresPerColumn = 6, squareSize: squareSize = 10, squarePadding: squarePadding = 2 })=>{
    const [tooltip, setTooltip] = (0, $1NEjv$useState)({
        visible: false,
        x: 0,
        y: 0,
        item: {}
    });
    // get the last 336 slots
    const slots = station.slots.slice(-336) || [];
    const rows = squaresPerColumn;
    const columns = Math.ceil(slots.length / rows);
    const cells = (0, $1NEjv$useMemo)(()=>slots.map((slot, i)=>{
            const col = Math.floor(i / rows);
            const row = i % rows;
            const { fill: fill, border: border } = $fa4da4836aa2485a$export$f7f5ac72fdf9da26(slot.count);
            return {
                _id: slot._id,
                x: col * (squareSize + squarePadding),
                y: row * (squareSize + squarePadding),
                fill: fill,
                border: border,
                count: slot.count || 0,
                date: slot.date ? new Date(slot.date).toLocaleString(undefined, {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: '2-digit',
                    hour12: true // Set to false if you want 24-hour format
                }) : '',
                gap: slot.gap || 0
            };
        }), [
        slots,
        rows,
        squareSize,
        squarePadding
    ]);
    const width = columns * (squareSize + squarePadding) - squarePadding;
    const height = rows * (squareSize + squarePadding) - squarePadding;
    const handleClick = (e, c)=>{
        console.log('Clicked cell:', c);
        window.location.href = `/recording/${c._id}`;
    };
    const handleMouseEnter = (e, c)=>{
        const rect = e.currentTarget.getBoundingClientRect();
        setTooltip({
            visible: true,
            x: rect.left + rect.width / 2,
            y: rect.top - 8,
            item: c
        });
    };
    const handleMouseMove = (e)=>{
        setTooltip((t)=>({
                ...t,
                x: e.clientX,
                y: e.clientY
            }));
    };
    const handleMouseLeave = ()=>{
        setTooltip((t)=>({
                ...t,
                visible: false
            }));
    };
    return /*#__PURE__*/ (0, $1NEjv$jsxs)("div", {
        style: {
            position: 'relative',
            display: 'inline-block'
        },
        children: [
            /*#__PURE__*/ (0, $1NEjv$jsx)("svg", {
                width: width,
                height: height,
                children: cells.map((c, idx)=>/*#__PURE__*/ (0, $1NEjv$jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, $1NEjv$jsx)("rect", {
                                x: c.x,
                                y: c.y,
                                width: squareSize,
                                height: squareSize,
                                fill: c.fill,
                                stroke: c.border,
                                rx: 2,
                                ry: 2,
                                onMouseEnter: (e)=>handleMouseEnter(e, c),
                                onMouseMove: handleMouseMove,
                                onMouseLeave: handleMouseLeave,
                                onClick: (e)=>handleClick(e, c)
                            }),
                            c.count < 0 && /*#__PURE__*/ (0, $1NEjv$jsx)("line", {
                                x1: c.x,
                                y1: c.y + squareSize,
                                x2: c.x + squareSize,
                                y2: c.y,
                                stroke: c.border,
                                strokeWidth: 1,
                                onMouseEnter: (e)=>handleMouseEnter(e, c),
                                onMouseMove: handleMouseMove,
                                onMouseLeave: handleMouseLeave,
                                onClick: (e)=>handleClick(e, c)
                            })
                        ]
                    }, idx))
            }),
            tooltip.visible && /*#__PURE__*/ (0, $1NEjv$jsxs)("div", {
                style: {
                    position: 'fixed',
                    top: tooltip.y - 30,
                    left: tooltip.x,
                    background: 'rgba(0,0,0,0.75)',
                    color: '#fff',
                    padding: '2px 6px',
                    borderRadius: '3px',
                    pointerEvents: 'none',
                    fontSize: '10px'
                },
                children: [
                    /*#__PURE__*/ (0, $1NEjv$jsx)("b", {
                        children: tooltip.item.date
                    }),
                    /*#__PURE__*/ (0, $1NEjv$jsx)("br", {}),
                    tooltip.item.count + (tooltip.item.count >= 0 ? ' matches' : ' - gap: ' + tooltip.item.gap + ' mins')
                ]
            })
        ]
    });
});
var $fa4da4836aa2485a$export$2e2bcd8739ae039 = $fa4da4836aa2485a$var$StationHeatmap;


function $cf91b3a579fa03ba$export$a467d8345b84e4f3() {
    const [stations, setStations] = (0, $1NEjv$useState)([]);
    const [loading, setLoading] = (0, $1NEjv$useState)(true);
    (0, $1NEjv$useEffect)(()=>{
        const fetchStations = async ()=>{
            const r = await (0, $3153bc3ffe81af94$export$2e2bcd8739ae039).post('station/getCachedStationData');
            if (r.error) {
                console.error(r.error);
                return;
            }
            setStations(r);
            setLoading(false);
        };
        fetchStations();
    }, []);
    if (loading) return /*#__PURE__*/ (0, $1NEjv$jsx)("h1", {
        children: "Loading..."
    });
    return /*#__PURE__*/ (0, $1NEjv$jsx)((0, $1NEjv$Fragment), {
        children: /*#__PURE__*/ (0, $1NEjv$jsx)((0, $1NEjv$Center), {
            children: /*#__PURE__*/ (0, $1NEjv$jsxs)((0, $1NEjv$Paper), {
                w: 1000,
                shadow: "sm",
                p: "md",
                m: "md",
                children: [
                    /*#__PURE__*/ (0, $1NEjv$jsx)("h1", {
                        children: "Stations"
                    }),
                    /*#__PURE__*/ (0, $1NEjv$jsx)((0, $1NEjv$Grid), {
                        p: "lg",
                        children: stations.map((station, index)=>/*#__PURE__*/ (0, $1NEjv$jsx)((0, $1NEjv$GridCol), {
                                span: 12,
                                sm: 6,
                                md: 4,
                                children: /*#__PURE__*/ (0, $1NEjv$jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $1NEjv$jsx)("h2", {
                                            children: station.full_name || station.name
                                        }),
                                        /*#__PURE__*/ (0, $1NEjv$jsx)((0, $fa4da4836aa2485a$export$2e2bcd8739ae039), {
                                            station: station
                                        })
                                    ]
                                })
                            }, index))
                    })
                ]
            })
        })
    });
} /*
return (
		<>
			<Center>
				<Paper w={1000} shadow="sm" p="md" m="md">
					<h1>Stations</h1>
					<List
						itemData={stations}
						itemCount={stations.length}
						height={800}
						itemSize={100}
					>
						{({ index, style }) => (
							<StationHeatmap
								data={stations[index]}
								index={index}
								style={style}
							/>
						)}
					</List>
				</Paper>
			</Center>
		</>
	);
	*/ 






function $b781062e7f3d7964$export$41afefe1f28d1937() {
    const [counts, setCounts] = (0, $1NEjv$useState)([]);
    const [loading, setLoading] = (0, $1NEjv$useState)(true);
    (0, $1NEjv$useEffect)(()=>{
        const fetchStations = async ()=>{
            const r = await (0, $3153bc3ffe81af94$export$2e2bcd8739ae039).post('recording/getFoxFiascoData', {
                limit: 5
            });
            if (r.error) {
                console.error(r.error);
                return;
            }
            setCounts(r);
            setLoading(false);
        };
        fetchStations();
    }, []);
    if (loading) return /*#__PURE__*/ (0, $1NEjv$jsx)("h1", {
        children: "Loading..."
    });
    return /*#__PURE__*/ (0, $1NEjv$jsx)((0, $1NEjv$Fragment), {
        children: /*#__PURE__*/ (0, $1NEjv$jsx)((0, $1NEjv$Center), {
            children: /*#__PURE__*/ (0, $1NEjv$jsxs)((0, $1NEjv$Paper), {
                w: 1000,
                shadow: "sm",
                p: "md",
                m: "md",
                children: [
                    /*#__PURE__*/ (0, $1NEjv$jsx)("h1", {
                        children: "Fox Fiasco"
                    }),
                    counts.countWithFingerprints,
                    " of ",
                    counts.count
                ]
            })
        })
    });
}









/****************************************************************************************
 * RecordingDetectionsSVG.ts
 * -----------------------------------------------------------------------------
 * Lightweight class that turns one JSON "recording" object into
 * an inline-SVG string.  Import it, feed it the data, drop the string into the DOM (or
 * wrap in a React component—see bottom).
 *
 *	Usage (React)
 *	─────────────
 *		import { RecordingDetectionsSVG, RecordingSVG } from './RecordingDetectionsSVG';
 *		…
 *		<RecordingSVG record={recordObj} />;
 ****************************************************************************************/ // ────────────────────────────────────────────────────────────────────────────────
// CONFIG (edit freely)
// ────────────────────────────────────────────────────────────────────────────────
const $128fe973530ffb7d$export$901e5e29563f7feb = 1; //0.5;					// 2 s = 1 px  (vertical)
const $128fe973530ffb7d$var$TIMELINE_X = 60; // x-pos of the vertical axis
const $128fe973530ffb7d$var$CONF_WIDTH = 60; // width of the music confidence bar (horizontal)
const $128fe973530ffb7d$export$224b37e9f3c17b9a = 20;
const $128fe973530ffb7d$var$LAYER_PAD = 3; // gap between coloured bars
const $128fe973530ffb7d$var$RECT_W = 14; // width of each detection bar
const $128fe973530ffb7d$var$DET_START_X = $128fe973530ffb7d$var$TIMELINE_X + $128fe973530ffb7d$var$CONF_WIDTH + $128fe973530ffb7d$var$LAYER_PAD;
const $128fe973530ffb7d$var$LABEL_START_X = $128fe973530ffb7d$var$DET_START_X + 3 * ($128fe973530ffb7d$var$RECT_W + $128fe973530ffb7d$var$LAYER_PAD) + 10; // x-pos of labels
const $128fe973530ffb7d$var$LABEL_PAD = 45; // gap between label and bar
const $128fe973530ffb7d$var$COLORS = {
    timeline: '#000000',
    conf: '#9dd8ff',
    watermark: '#800080',
    nfp: '#d62828'
};
class $128fe973530ffb7d$export$2e2bcd8739ae039 {
    record;
    pxPerSec;
    durationSec;
    constructor(record, pxPerSec = $128fe973530ffb7d$export$901e5e29563f7feb){
        this.record = record;
        this.pxPerSec = pxPerSec;
        this.durationSec = 1800;
        this.y = (s)=>s * this.pxPerSec;
        this.line = (x1, y1, x2, y2, c = $128fe973530ffb7d$var$COLORS.timeline, w = 1)=>`<line x1 = "${x1}" y1 = "${y1}" x2 = "${x2}" y2 = "${y2}" stroke = "${c}" stroke-width="${w}" style="z-index: 1;" /> `;
        this.rect = (x, y, h, c, rx = 3, ry = 3)=>`<rect x = "${x}" y = "${y}" width = "${$128fe973530ffb7d$var$RECT_W}" height = "${h}" fill = "${c}" rx="${rx}" ry="${ry}" stroke="white" stroke-width="1" /> `;
        this.text = (x, y, txt, anchor = 'start', rotate = 0)=>`<text x="${x}" y="${y}" font-size="10" text-anchor="${anchor}" dominant-baseline="middle" transform="rotate(${rotate} ${x} ${y})" style="z-index: 10;" fill="black" stroke="white" stroke-width="2.5" paint-order="stroke" stroke-linejoin="round"> ${txt} </text>`;
    }
    // public façade
    build() {
        const colLabels = [
            'DIGI',
            'NFP1',
            'NFP2'
        ]; // column labels
        const h = $128fe973530ffb7d$export$224b37e9f3c17b9a + this.y(this.durationSec);
        const w = $128fe973530ffb7d$var$TIMELINE_X + $128fe973530ffb7d$var$CONF_WIDTH + colLabels.length * ($128fe973530ffb7d$var$RECT_W + $128fe973530ffb7d$var$LAYER_PAD) + 350;
        let out = [
            `<svg xmlns = "http://www.w3.org/2000/svg" width = "${w}" height = "${h + 40}" font - family="sans-serif" > `,
            this.musicConfidencePolygon(h),
            this.line($128fe973530ffb7d$var$TIMELINE_X, $128fe973530ffb7d$export$224b37e9f3c17b9a, $128fe973530ffb7d$var$TIMELINE_X, h, $128fe973530ffb7d$var$COLORS.timeline, 2)
        ];
        // minute ticks
        for(let s = 0; s <= this.durationSec; s += 60){
            const y = this.y(s) + $128fe973530ffb7d$export$224b37e9f3c17b9a;
            out.push(this.line($128fe973530ffb7d$var$TIMELINE_X - 4, y, $128fe973530ffb7d$var$TIMELINE_X, y), this.text($128fe973530ffb7d$var$TIMELINE_X - 36, y, String(s), 'end'));
        }
        // column labels
        for(let i = 0; i < colLabels.length; i++){
            const x = $128fe973530ffb7d$var$RECT_W + $128fe973530ffb7d$var$DET_START_X + i * ($128fe973530ffb7d$var$RECT_W + $128fe973530ffb7d$var$LAYER_PAD);
            out.push(this.text(x, $128fe973530ffb7d$export$224b37e9f3c17b9a - 10, colLabels[i], 'middle', -45));
        }
        this.paintLayer(this.grabWatermarks(), 0, $128fe973530ffb7d$var$COLORS.watermark, out);
        this.paintLayer(this.grabNfp(1), 1, '#CCCCCC', out); // classification 1 (less confident) - grey
        this.paintLayer(this.grabNfp(2), 2, $128fe973530ffb7d$var$COLORS.nfp, out); // classification 2 (more confident) - red
        out.push('</svg>');
        return out.join('\n');
    }
    // ───────── helpers ─────────
    y;
    line;
    rect;
    text;
    musicConfidencePolygon(h) {
        const musicConfidence = this.record.nfp?.music_confidence;
        if (!musicConfidence || !musicConfidence.length) return '';
        // Array of numbers, one per second (index = time in seconds)
        const pts = musicConfidence.map((confidence, time)=>`${$128fe973530ffb7d$var$TIMELINE_X + confidence * $128fe973530ffb7d$var$CONF_WIDTH},${this.y(time) + $128fe973530ffb7d$export$224b37e9f3c17b9a}`);
        pts.push(`${$128fe973530ffb7d$var$TIMELINE_X},${h}`, `${$128fe973530ffb7d$var$TIMELINE_X},${$128fe973530ffb7d$export$224b37e9f3c17b9a}`);
        return `<polygon points="${pts.join(' ')}" fill="${$128fe973530ffb7d$var$COLORS.conf}" opacity="0.7"/>`;
    }
    paintLayer(list, idx, color, out) {
        const x = $128fe973530ffb7d$var$DET_START_X + idx * ($128fe973530ffb7d$var$RECT_W + $128fe973530ffb7d$var$LAYER_PAD);
        const gap = 20; // minimum gap between labels
        const xLbl = $128fe973530ffb7d$var$LABEL_START_X + idx * $128fe973530ffb7d$var$LABEL_PAD;
        const xLine = xLbl - 2;
        // First pass: draw all detection bars
        list.forEach((m)=>{
            const yBar = this.y(m.start) + $128fe973530ffb7d$export$224b37e9f3c17b9a;
            const h = Math.max(this.y(m.end - m.start), 2);
            out.push(this.rect(x, yBar, h, color));
        });
        // Second pass: group labels by start position (not by bar overlap)
        let lastLblY = -1000000000;
        let pendingGroup = [];
        let groupStartY = 0;
        const flushGroup = ()=>{
            if (pendingGroup.length === 0) return;
            const first = pendingGroup[0];
            // Strip period and everything after from id
            let displayId = (first.id + '').includes('.') ? first.id.split('.')[0] : first.id;
            if (pendingGroup.length === 1) {
                // Single item - show normally
                const infoJson = JSON.stringify(first).replace(/"/g, '&quot;');
                out.push(this.line(x + $128fe973530ffb7d$var$RECT_W, groupStartY, xLine, groupStartY, color), `<text transform="rotate(30 ${xLbl} ${groupStartY})" x="${xLbl}" y="${groupStartY}" font-size="10" data-seek-time="${first.start}" data-detection-info="${infoJson}" style="cursor: pointer;">${displayId} (${(first.end - first.start).toFixed(0)})</text>`);
            } else {
                // Multiple items - show first + "more"
                const infoJson = JSON.stringify(pendingGroup).replace(/"/g, '&quot;');
                out.push(this.line(x + $128fe973530ffb7d$var$RECT_W, groupStartY, xLine, groupStartY, color), `<text transform="rotate(30 ${xLbl} ${groupStartY})" x="${xLbl}" y="${groupStartY}" font-size="10" data-seek-time="${first.start}" data-detection-info="${infoJson}" style="cursor: pointer;">${displayId} +${pendingGroup.length - 1} more</text>`);
            }
            pendingGroup = [];
        };
        list.forEach((m)=>{
            const yBar = this.y(m.start) + $128fe973530ffb7d$export$224b37e9f3c17b9a;
            if (yBar - lastLblY < gap) // Too close to last label - add to pending group
            pendingGroup.push(m);
            else {
                // Far enough - flush previous group and start new one
                flushGroup();
                pendingGroup = [
                    m
                ];
                groupStartY = yBar;
                lastLblY = yBar;
            }
        });
        // Flush any remaining group
        flushGroup();
    }
    grabWatermarks() {
        return (this.record.data?.matches ?? []).map((m)=>({
                start: +m.start,
                end: +m.end,
                id: m.track?.raw?.file_id
            }));
    }
    grabNfp(classification) {
        if (!this.record.nfp) return [];
        const data = this.record.nfp;
        if (!data.finalMatches && !data.final_matches) return [];
        // figure out which final matches key
        const finals = data.finalMatches || data.final_matches;
        const matches = finals.filter((m)=>m.classification === classification).map((m)=>({
                start: +m.start || +m.start_time || 0,
                end: +m.end || +m.end_time,
                id: m.fileId || m.file_id,
                raw: m
            }));
        return matches;
    }
}


function $aa51578a56fb64a4$export$2e2bcd8739ae039({ record: record, currentTime: currentTime = 0, onSeek: onSeek }) {
    const handleClick = (e)=>{
        // Check for data-seek-time on the clicked element or its parent
        let target = e.target;
        let seekTime = target.dataset?.seekTime || target.getAttribute?.('data-seek-time');
        let detectionInfo = target.dataset?.detectionInfo || target.getAttribute?.('data-detection-info');
        // Also check parent elements (in case click is on text content)
        if (!seekTime && target.parentElement) {
            seekTime = target.parentElement.dataset?.seekTime || target.parentElement.getAttribute?.('data-seek-time');
            detectionInfo = target.parentElement.dataset?.detectionInfo || target.parentElement.getAttribute?.('data-detection-info');
        }
        if (seekTime && onSeek) {
            e.preventDefault();
            e.stopPropagation();
            // Log detection info if available
            if (detectionInfo) try {
                console.log(JSON.parse(detectionInfo));
            } catch (err) {
            // ignore parse errors
            }
            onSeek(parseFloat(seekTime));
        }
    };
    // Calculate playhead Y position based on SVG constants
    const playheadY = (0, $128fe973530ffb7d$export$224b37e9f3c17b9a) + currentTime * (0, $128fe973530ffb7d$export$901e5e29563f7feb);
    return /*#__PURE__*/ (0, $1NEjv$jsxs)("div", {
        style: {
            position: 'relative'
        },
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0, $1NEjv$jsx)("div", {
                style: {
                    position: 'absolute',
                    top: playheadY,
                    left: 0,
                    right: 0,
                    height: 2,
                    background: '#ff0000',
                    pointerEvents: 'none',
                    zIndex: 0
                }
            }),
            /*#__PURE__*/ (0, $1NEjv$jsx)("div", {
                style: {
                    position: 'relative',
                    zIndex: 1
                },
                dangerouslySetInnerHTML: {
                    __html: new (0, $128fe973530ffb7d$export$2e2bcd8739ae039)(record).build()
                }
            })
        ]
    });
}


// Format seconds to MM:SS timecode
function $c24f0fe86a335ba1$var$formatTimecode(seconds) {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
}
function $c24f0fe86a335ba1$export$b8cb238a79c4ebf1() {
    const { recording_id: recording_id } = (0, $1NEjv$useParams)();
    const [r, setR] = (0, $1NEjv$useState)(null);
    const [loading, setLoading] = (0, $1NEjv$useState)(true);
    const [videoUrl, setVideoUrl] = (0, $1NEjv$useState)(null);
    const [transcoding, setTranscoding] = (0, $1NEjv$useState)(false);
    const [currentTime, setCurrentTime] = (0, $1NEjv$useState)(0);
    const videoRef = (0, $1NEjv$useRef)(null);
    // Update currentTime state on video timeupdate
    const handleTimeUpdate = (0, $1NEjv$useCallback)(()=>{
        if (videoRef.current) setCurrentTime(videoRef.current.currentTime);
    }, []);
    // Seek handler - called when clicking on detection IDs in the SVG
    const handleSeek = (0, $1NEjv$useCallback)((time)=>{
        if (!videoRef.current) return;
        videoRef.current.currentTime = time;
        if (videoRef.current.paused) videoRef.current.play().catch(()=>{});
    }, []);
    // Fetch recording data
    (0, $1NEjv$useEffect)(()=>{
        const fetchRecording = async ()=>{
            const r = await (0, $3153bc3ffe81af94$export$2e2bcd8739ae039).post('recording/getRecording', {
                id: recording_id,
                getTracks: 1
            });
            if (r.error) {
                console.error(r.error);
                return;
            }
            setR(r);
            setLoading(false);
        };
        fetchRecording();
    }, [
        recording_id
    ]);
    // Get MP4 video URL (transcode if needed)
    (0, $1NEjv$useEffect)(()=>{
        if (!r) return;
        const getVideoUrl = async ()=>{
            // Check if it's a .ts file that needs transcoding
            const isTsFile = r.filename?.toLowerCase().endsWith('.ts');
            if (isTsFile) {
                setTranscoding(true);
                const result = await (0, $3153bc3ffe81af94$export$2e2bcd8739ae039).post('recording/getRecordingMp4', {
                    id: recording_id
                });
                setTranscoding(false);
                if (result.error) {
                    console.error('Transcode error:', result.error);
                    // Fall back to original URL
                    setVideoUrl(r.url);
                } else setVideoUrl(result.url);
            } else // Use original URL for non-TS files
            setVideoUrl(r.url);
        };
        getVideoUrl();
    }, [
        r,
        recording_id
    ]);
    // Set up video element when URL is ready
    (0, $1NEjv$useEffect)(()=>{
        if (!videoUrl || !videoRef.current) return;
        const videoElement = videoRef.current;
        videoElement.src = videoUrl;
        videoElement.addEventListener('timeupdate', handleTimeUpdate);
        return ()=>{
            videoElement.removeEventListener('timeupdate', handleTimeUpdate);
        };
    }, [
        videoUrl,
        handleTimeUpdate
    ]);
    // calculate % of the recording that is music from musicConfidence data - r.musicConfidence
    const calculateMusicPercentage = (recording)=>{
        if (!recording || !recording.musicConfidence) return 0;
        const totalDuration = recording.musicConfidence.length;
        const musicDuration = recording.musicConfidence.reduce((acc, val)=>acc + (val.confidence > 0.1 ? 1 : 0), 0);
        return musicDuration / totalDuration * 100;
    };
    // If the recording is still loading, say so
    if (loading) return /*#__PURE__*/ (0, $1NEjv$jsx)("h1", {
        children: "Loading..."
    });
    return /*#__PURE__*/ (0, $1NEjv$jsxs)((0, $1NEjv$Fragment), {
        children: [
            /*#__PURE__*/ (0, $1NEjv$jsx)((0, $1NEjv$Center), {
                children: /*#__PURE__*/ (0, $1NEjv$jsxs)((0, $1NEjv$Paper), {
                    w: 1000,
                    shadow: "sm",
                    p: "md",
                    m: "md",
                    children: [
                        /*#__PURE__*/ (0, $1NEjv$jsx)((0, $1NEjv$Code), {
                            children: r.filename
                        }),
                        /*#__PURE__*/ (0, $1NEjv$jsx)("br", {}),
                        r.musicConfidence && /*#__PURE__*/ (0, $1NEjv$jsxs)((0, $1NEjv$Code), {
                            children: [
                                "Music Percentage: ",
                                calculateMusicPercentage(r).toFixed(2),
                                "%"
                            ]
                        }),
                        /*#__PURE__*/ (0, $1NEjv$jsx)((0, $1NEjv$Container), {
                            mt: "md",
                            children: /*#__PURE__*/ (0, $1NEjv$jsx)((0, $aa51578a56fb64a4$export$2e2bcd8739ae039), {
                                record: r,
                                currentTime: currentTime,
                                onSeek: handleSeek
                            })
                        })
                    ]
                })
            }),
            r && /*#__PURE__*/ (0, $1NEjv$jsxs)("div", {
                style: {
                    position: 'fixed',
                    bottom: 20,
                    right: 20,
                    zIndex: 1000,
                    background: '#1a1a1a',
                    borderRadius: 8,
                    padding: 12,
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)'
                },
                children: [
                    /*#__PURE__*/ (0, $1NEjv$jsx)("div", {
                        style: {
                            fontSize: '2.5rem',
                            fontFamily: 'monospace',
                            fontWeight: 'bold',
                            color: '#fff',
                            textAlign: 'center',
                            marginBottom: 8,
                            textShadow: '0 0 10px rgba(255, 255, 255, 0.3)'
                        },
                        children: $c24f0fe86a335ba1$var$formatTimecode(currentTime)
                    }),
                    transcoding && /*#__PURE__*/ (0, $1NEjv$jsxs)("div", {
                        style: {
                            width: 320,
                            height: 180,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: '#000',
                            borderRadius: 4,
                            color: '#fff'
                        },
                        children: [
                            /*#__PURE__*/ (0, $1NEjv$jsx)((0, $1NEjv$Loader), {
                                color: "white",
                                size: "lg"
                            }),
                            /*#__PURE__*/ (0, $1NEjv$jsx)("div", {
                                style: {
                                    marginTop: 12
                                },
                                children: "Transcoding to MP4..."
                            })
                        ]
                    }),
                    !transcoding && /*#__PURE__*/ (0, $1NEjv$jsx)("video", {
                        ref: videoRef,
                        controls: true,
                        playsInline: true,
                        style: {
                            width: 320,
                            borderRadius: 4,
                            display: 'block'
                        }
                    })
                ]
            })
        ]
    });
}







// Generate last N days as dropdown options
function $2eaf15eb63ff1c61$var$generateDayOptions(numDays) {
    const options = [
        {
            value: '',
            label: 'All (Recent 50)'
        }
    ];
    const today = new Date();
    for(let i = 0; i < numDays; i++){
        const date = new Date(today);
        date.setDate(date.getDate() - i);
        const dateStr = date.toISOString().split('T')[0]; // YYYY-MM-DD
        const label = date.toLocaleDateString('en-US', {
            weekday: 'short',
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
        options.push({
            value: dateStr,
            label: label
        });
    }
    return options;
}
function $2eaf15eb63ff1c61$export$4302a6400cbb093e() {
    const [recordings, setRecordings] = (0, $1NEjv$useState)([]);
    const [loading, setLoading] = (0, $1NEjv$useState)(true);
    const [selectedDate, setSelectedDate] = (0, $1NEjv$useState)('');
    const dayOptions = (0, $1NEjv$useMemo)(()=>$2eaf15eb63ff1c61$var$generateDayOptions(30), []);
    (0, $1NEjv$useEffect)(()=>{
        const fetchRecordings = async ()=>{
            setLoading(true);
            const params = selectedDate ? {
                date: selectedDate
            } : {};
            const r = await (0, $3153bc3ffe81af94$export$2e2bcd8739ae039).post('recording/getNfpRecordings', params);
            if (r.error) {
                console.error(r.error);
                setLoading(false);
                return;
            }
            setRecordings(r);
            setLoading(false);
        };
        fetchRecordings();
    }, [
        selectedDate
    ]);
    const rows = recordings.map((rec)=>/*#__PURE__*/ (0, $1NEjv$jsxs)((0, $1NEjv$Table).Tr, {
            children: [
                /*#__PURE__*/ (0, $1NEjv$jsx)((0, $1NEjv$Table).Td, {
                    children: /*#__PURE__*/ (0, $1NEjv$jsx)((0, $1NEjv$Anchor), {
                        component: (0, $1NEjv$Link),
                        to: `/recording/${rec.filename}`,
                        children: rec.filename
                    })
                }),
                /*#__PURE__*/ (0, $1NEjv$jsx)((0, $1NEjv$Table).Td, {
                    children: new Date(rec.date).toLocaleString()
                }),
                /*#__PURE__*/ (0, $1NEjv$jsx)((0, $1NEjv$Table).Td, {
                    children: rec.watermarkMatches
                }),
                /*#__PURE__*/ (0, $1NEjv$jsx)((0, $1NEjv$Table).Td, {
                    children: rec.nfpMatches
                })
            ]
        }, rec._id));
    return /*#__PURE__*/ (0, $1NEjv$jsx)((0, $1NEjv$Center), {
        children: /*#__PURE__*/ (0, $1NEjv$jsxs)((0, $1NEjv$Paper), {
            w: 1000,
            shadow: "sm",
            p: "md",
            m: "md",
            children: [
                /*#__PURE__*/ (0, $1NEjv$jsxs)((0, $1NEjv$Group), {
                    justify: "space-between",
                    mb: "md",
                    children: [
                        /*#__PURE__*/ (0, $1NEjv$jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $1NEjv$jsx)("h1", {
                                    style: {
                                        margin: 0
                                    },
                                    children: "NFP Watch"
                                }),
                                /*#__PURE__*/ (0, $1NEjv$jsx)("p", {
                                    style: {
                                        margin: 0,
                                        color: '#666'
                                    },
                                    children: selectedDate ? `Recordings from ${selectedDate}` : 'Last 50 recordings with NFP data'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $1NEjv$jsx)((0, $1NEjv$Select), {
                            label: "Select Day",
                            placeholder: "Pick a day",
                            data: dayOptions,
                            value: selectedDate,
                            onChange: setSelectedDate,
                            searchable: true,
                            w: 220
                        })
                    ]
                }),
                loading ? /*#__PURE__*/ (0, $1NEjv$jsx)((0, $1NEjv$Center), {
                    children: /*#__PURE__*/ (0, $1NEjv$jsx)("h2", {
                        children: "Loading..."
                    })
                }) : /*#__PURE__*/ (0, $1NEjv$jsxs)((0, $1NEjv$Table), {
                    striped: true,
                    highlightOnHover: true,
                    children: [
                        /*#__PURE__*/ (0, $1NEjv$jsx)((0, $1NEjv$Table).Thead, {
                            children: /*#__PURE__*/ (0, $1NEjv$jsxs)((0, $1NEjv$Table).Tr, {
                                children: [
                                    /*#__PURE__*/ (0, $1NEjv$jsx)((0, $1NEjv$Table).Th, {
                                        children: "Filename"
                                    }),
                                    /*#__PURE__*/ (0, $1NEjv$jsx)((0, $1NEjv$Table).Th, {
                                        children: "Date"
                                    }),
                                    /*#__PURE__*/ (0, $1NEjv$jsx)((0, $1NEjv$Table).Th, {
                                        children: "Watermark Matches"
                                    }),
                                    /*#__PURE__*/ (0, $1NEjv$jsx)((0, $1NEjv$Table).Th, {
                                        children: "NFP Matches"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $1NEjv$jsx)((0, $1NEjv$Table).Tbody, {
                            children: rows.length > 0 ? rows : /*#__PURE__*/ (0, $1NEjv$jsx)((0, $1NEjv$Table).Tr, {
                                children: /*#__PURE__*/ (0, $1NEjv$jsx)((0, $1NEjv$Table).Td, {
                                    colSpan: 4,
                                    style: {
                                        textAlign: 'center'
                                    },
                                    children: "No recordings found for this date"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
}


// other css files are required only if
// you are using components from the corresponding package
// import '@mantine/dates/styles.css';
// import '@mantine/dropzone/styles.css';
// import '@mantine/code-highlight/styles.css';
// ...
const $c77c4e5cf3a3da97$var$overrides = (0, $1NEjv$createTheme)({
    fontFamily: 'Noto Sans, sans-serif',
    fontFamilyMonospace: 'Roboto Mono, monospace',
    'ocean-blue': [
        '#7AD1DD',
        '#5FCCDB',
        '#44CADC',
        '#2AC9DE',
        '#1AC2D9',
        '#11B7CD',
        '#09ADC3',
        '#0E99AC',
        '#128797',
        '#147885'
    ],
    'bright-pink': [
        '#F0BBDD',
        '#ED9BCF',
        '#EC7CC3',
        '#ED5DB8',
        '#F13EAF',
        '#F71FA7',
        '#FF00A1',
        '#E00890',
        '#C50E82',
        '#AD1374'
    ]
});
const $c77c4e5cf3a3da97$var$theme = (0, $1NEjv$mergeMantineTheme)((0, $1NEjv$DEFAULT_THEME), $c77c4e5cf3a3da97$var$overrides);
function $c77c4e5cf3a3da97$export$86fbec116b87613f() {
    return /*#__PURE__*/ (0, $1NEjv$jsx)((0, $1NEjv$MantineProvider), {
        theme: $c77c4e5cf3a3da97$var$theme,
        defaultColorScheme: "light",
        children: /*#__PURE__*/ (0, $1NEjv$jsx)((0, $1NEjv$BrowserRouter), {
            children: /*#__PURE__*/ (0, $1NEjv$jsxs)((0, $1NEjv$Routes), {
                children: [
                    /*#__PURE__*/ (0, $1NEjv$jsx)((0, $1NEjv$Route), {
                        path: "/",
                        element: /*#__PURE__*/ (0, $1NEjv$jsx)("h1", {
                            children: "HOME"
                        })
                    }),
                    /*#__PURE__*/ (0, $1NEjv$jsx)((0, $1NEjv$Route), {
                        path: "test",
                        element: /*#__PURE__*/ (0, $1NEjv$jsx)("h1", {
                            children: "TEST"
                        })
                    }),
                    /*#__PURE__*/ (0, $1NEjv$jsx)((0, $1NEjv$Route), {
                        path: "stations",
                        element: /*#__PURE__*/ (0, $1NEjv$jsx)((0, $cf91b3a579fa03ba$export$a467d8345b84e4f3), {})
                    }),
                    /*#__PURE__*/ (0, $1NEjv$jsx)((0, $1NEjv$Route), {
                        path: "foxfiasco",
                        element: /*#__PURE__*/ (0, $1NEjv$jsx)((0, $b781062e7f3d7964$export$41afefe1f28d1937), {})
                    }),
                    /*#__PURE__*/ (0, $1NEjv$jsx)((0, $1NEjv$Route), {
                        path: "recording/:recording_id",
                        element: /*#__PURE__*/ (0, $1NEjv$jsx)((0, $c24f0fe86a335ba1$export$b8cb238a79c4ebf1), {})
                    }),
                    /*#__PURE__*/ (0, $1NEjv$jsx)((0, $1NEjv$Route), {
                        path: "nfp-watch",
                        element: /*#__PURE__*/ (0, $1NEjv$jsx)((0, $2eaf15eb63ff1c61$export$4302a6400cbb093e), {})
                    }),
                    /*#__PURE__*/ (0, $1NEjv$jsx)((0, $1NEjv$Route), {
                        path: "*",
                        element: /*#__PURE__*/ (0, $1NEjv$jsx)("h1", {
                            children: "404"
                        })
                    })
                ]
            })
        })
    });
}


const $ee0d76bb1b3ee43e$var$container = document.getElementById("main");
const $ee0d76bb1b3ee43e$var$root = (0, $1NEjv$createRoot)($ee0d76bb1b3ee43e$var$container);
$ee0d76bb1b3ee43e$var$root.render(/*#__PURE__*/ (0, $1NEjv$jsx)((0, $c77c4e5cf3a3da97$export$86fbec116b87613f), {}));


//# sourceMappingURL=site.ca6eed82.js.map
